import { Button, Box, Divider, styled, Typography, useMediaQuery } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { mapPlatformToInfo } from 'src/helpers/mapPlatformToData';
import { whatsproColors } from 'src/theme/colors'

const colors = whatsproColors;

const ContainerButton = styled(Button)(
    () => `
    font-size: 1.3em;
    font-weight: 500;
    padding: 0.4em 0.7em;
    color: ${colors.white};
    background: ${colors.primaryDark};
    text-transform: none;
    border-radius: 0.7em;
    width: 90vw;
    max-width: 25em;
  `
);

const EtapaCrecimiento = ({ title, description }) => {

    const isDesktop = useMediaQuery('(min-width:1024px)');

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent='space-evenly'
            alignItems={'center'}
            textAlign={'center'}
            padding={1}
            sx={{
                borderRadius: '15px',
                background: '#F1F1F1',
                height: isDesktop ? '20em' : '15em',
                width: '100%',
                color: colors.primaryDark,
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
                maxWidth: '25em'
            }}
        >
            <Typography
                variant='h2'
                fontSize={isDesktop ? '30px' : '25px'}
                fontWeight={600}
            >
                {title}
            </Typography>
            <Divider variant='middle' sx={{ alignSelf: 'center', width: '20%', border: `1px solid ${colors.primaryDark}` }} />
            <Typography
                variant='h4'
                fontSize={isDesktop ? '17px' : '17px'}
                fontWeight={500}
                width={'90%'}
            >
                {description}
            </Typography>
        </Box>
    )
}

export const Contacto = ({platform, validPlatform}) => {
    const isDesktop = useMediaQuery('(min-width:1024px)');
    const navigate = useNavigate();

    const handleClick = () => {
        if(validPlatform){
            window.location.href = mapPlatformToInfo[platform].url;
        } else{
            window.location.href = mapPlatformToInfo['particular'].url;
        }
    }

    return (
        <Box
            sx={{
                background: colors.secondary,
                color: colors.white,
                padding: '2em',
                paddingBottom: '3em'
            }}
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems={!isDesktop && "center"}
                // justifyContent="center"
                textAlign='center'
                gap={isDesktop ? 3 : 2}
            >
                <Typography
                    variant="h5"
                    fontSize={isDesktop ? '22px' : '16px'}
                    fontWeight={700}
                    color={colors.primaryDark}
                    gutterBottom
                >
                    EMPEZÁ YA
                </Typography>
                <Typography
                    variant="h2"
                    fontSize={isDesktop ? '50px' : '30px'}
                    fontWeight={600}
                    color={colors.white}
                    paddingBottom={'0.5em'}
                >
                    Suscribite y potenciá tu Tienda
                </Typography>
                <Typography
                    variant="h2"
                    fontSize={isDesktop ? '20px' : '18px'}
                    fontWeight={400}
                    color={colors.white}
                    paddingBottom={'1em'}
                >
                    Con <span style={{color: colors.primary}}>WhatsPRO</span> te acompañamos en todas tus etapas de crecimiento.
                </Typography>
                <Box
                    display='flex'
                    flexDirection={isDesktop ? 'row' : 'column'}
                    justifyContent='center'
                    gap={isDesktop ? 4 : 2}
                >
                    <EtapaCrecimiento
                        title='Emprendimientos'
                        description='Automatizá las preguntas más frecuentes de tus clientes y concentrá tu atención en lo que más te gusta: vender.'
                    />
                    <EtapaCrecimiento
                        title='Mediana empresa'
                        description='Ofrecé un servicio de atención al cliente de calidad y aumentá la satisfacción de tus clientes.'
                    />
                    <EtapaCrecimiento
                        title='Gran empresa'
                        description='Canalizá eficientemente las consultas de tus clientes y optimizá los tiempo de respuesta y duración de las consultas.'
                    />
                </Box>
                <ContainerButton
                    variant='contained'
                    fullWidth={!isDesktop}
                    sx={{
                        '&:hover': {
                            background: `${colors.primaryDark}`
                        },
                        marginTop: '1em',
                        alignSelf: 'center'
                    }}
                    onClick={handleClick}
                >
                    Comenzar con WhatsPRO
                </ContainerButton>
            </Box>
        </Box>
    )
}
